/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Activity_HideInputs */



/**
* | output |
* | --- |
* | "Hide" |
*
* @param {Assistant_Activity_HideInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_hide = /** @type {((inputs?: Assistant_Activity_HideInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_HideInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cacher")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verstecken")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nascondere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скрывать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esconder")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("隐藏")
	if (locale === "ja") return /** @type {LocalizedString} */ ("隠れる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("छिपाना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Esconder")
	return /** @type {LocalizedString} */ ("Hide")
});